import Math from '@/utils/math';
import { formatDate } from '@/utils/date';
import utilsAuth from '@/utils/auth';
export default {
	methods: {
        checkShopDetail () {
            let shopInfo = utilsAuth.getShopInfo();
            // 店铺资料不全
            if (!shopInfo.shop_address || !shopInfo.shop_tel) {
                this.$Dialog.open({
                    title: this.$Lang('完善店铺资料'),
                    msg: this.$Lang('记得完善店铺资料哦，客人还等着认识你。'),
                    type: 'warning',
                    confirmButtonText: this.$Lang('确定'),
                    onConfirm: () => {
                        this.$router.push({ name: 'settingShop' })
                    }
                })
            }
        },
		objIsEmpty (obj) {
			for (let key in obj) {
				if (obj.hasOwnProperty(key)) {
					return false
				}
		    }
		    return true
		},
		hasPermission (workname, routeName) {
			const has = this.$store.getters.workground === false || this.$store.getters.workground.some(name => name === workname)

            if (has && routeName) {
                return this.$store.state.permission.routersName.some(name => name === routeName)
            }

            if (this.$store.getters.proWorkground.length) {
                return !this.$store.getters.proWorkground.some(name => name === workname)
            }

            return has
		},
        // 过滤掉无效店铺的数据
        filterDataByShop (data) {
            let shopList = []
            let ret = []
            if (this.$store.state.user.shopList.length) {
                shopList    = this.$store.state.user.shopList
            } else {
                shopList[0] = this.$store.state.user.shopInfo
            }
            for (let i in data) {
                if (Number(data[i].shop_id) > 0) {
                    let _find = 0
                    for (let j in shopList) {
                        if (Number(shopList[j].shop_id) === Number(data[i].shop_id) && Number(shopList[j].shop_status) === 1) {
                            _find = 1
                        }
                    }
                    if (_find === 1) {
                        ret.push(data[i])
                    }
                }
            }
            return ret
        },
        // 获得当前时间/日期的unix时间
        getNowUnixTime (type = 1) {
            // 当前日期
            let _date = new Date();
            let _time = 0;
            if (type === 1) {
                let _y = _date.getFullYear();
                let _m = _date.getMonth() + 1;
                let _d = _date.getDate();
                let _day = _y + '-' + _m + '-' + _d + ' 00:00:00:000'
                let _ndate = new Date(_day);
                _time = Math.round(_ndate.getTime() / 1000);
            } else {
                _time = Math.round(_date.getTime() / 1000);
            }   
            return _time;
        },  
        getStartEndDateFromRangeByDatePicker (range, type = 1) {
            let _date = new Date();
            let startTime = _date.getTime() / 1000;
            let endTime = startTime + 86400;
            if (typeof range === 'object') {
                startTime = range[0];
                endTime   = range[1]
            }
            if (type === 1) {
                startTime = formatDate(startTime, 'yyyy-MM-dd');
                endTime = formatDate(endTime, 'yyyy-MM-dd');
            } else if (type === 3) {
                startTime = formatDate(startTime, 'yyyy-MM');
                endTime = formatDate(endTime, 'yyyy-MM');
            } else {
                startTime = formatDate(startTime, 'yyyy-MM-dd hh:mm:ss');
                endTime = formatDate(endTime, 'yyyy-MM-dd hh:mm:ss');
            }
            let ret = {startTime: startTime, endTime: endTime};
            return ret;
        },
        getStartEndDateFromRange (range, type = 1) {
            let _date = new Date();
            let startTime = _date.getTime() / 1000;
            let endTime = startTime + 86400;
            startTime = formatDate(startTime, 'yyyy-MM-dd');
            endTime = formatDate(endTime, 'yyyy-MM-dd');
            if (typeof range === 'string') {
                let _arr    = range.split(' '); 
                if (type === 1) {
                    startTime   = _arr[0];
                    endTime     = _arr[2];
                } else {
                    startTime = _arr[0] + ' ' + _arr[1];
                    endTime = _arr[3] + ' ' + _arr[4];
                }
            } else if (typeof range === 'object') {
                startTime   = range[0];
                endTime     = range[1];
            }
            if (endTime === '' || typeof endTime === 'undefined') {
                endTime = startTime;
            }
            if (startTime === endTime && type === 1) {
                let _time = new Date(endTime + ' 00:00:00')
                endTime = formatDate(_time.getTime() / 1000 + 86400, 'yyyy-MM-dd');
            }
            let ret = {startTime: startTime, endTime: endTime};
            return ret;
        },
        _math () {
            return {
                // 保留小数位
                setFixedNum : Math.setFixedNum,
                // 加法
                plus : Math.plus,
                // 减法
                minus : Math.minus,
                // 乘法
                multiple : Math.multiple,
                // 除法
                division : Math.division
            }
        },
        /**
         * 取出数组中对象值
         *
         * @param dataList     数据列表
         * @param diffKey      需要比较的对象名
         * @param diffValue    需要比较的对象值
         * @param takeKey      获取比较到的数据名
         *
         */
        getArrayObjValue (dataList, diffKey, diffValue, takeKey) {
            const hasData = dataList.filter(data => data[diffKey] === diffValue)

            if (hasData.length) {
                return hasData[0][takeKey]
            }

            return diffValue
        },
        getShopName (shopId) {
            const row = this.$store.getters.shopList.filter(data => data.shop_id === parseInt(shopId))

            if (row.length) {
                return row[0].shop_name
            }
        }
	},
	data () {
		return {
			CONFIG: {
				PAGE_MAX_ROW: 20
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/common.js